import React, { useState, useCallback, useRef } from 'react';
import './index.scss';
import CardSlot from '@/pages/dashboard/components/CardSlot';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import SvgIcon from '@/pages/home/components/SvgIcon';

const BUBBLE_WIDTH = 510;

const MultiProgressCard = (props: any) => {
  const { data, handelDownload, title: mainTitle, sortValue, handleSort, item, header, secTitle } = props;
  const { isLoading, isError, isNoData, data: dataList } = data;

  const [hoveredRow, setHoveredRow] = useState<number>(-1);
  const [bubblePos, setBubblePos] = useState<{ x: number; y: number; }>({ x: 0, y: 0 });
  const bubbleRef = useRef<HTMLDivElement>(null);
  const mainRef = useRef<HTMLDivElement>(null);

  const calcPosition = (clientX: number, clientY: number): { x: number; y: number; } => {
    const childWidth = bubbleRef.current?.offsetWidth || BUBBLE_WIDTH;
    const width = mainRef.current?.offsetWidth || 0;
    const distance = window.innerWidth - width;
    const maxLeft = window.innerWidth - childWidth - 80;
    const raw = clientX > maxLeft ? clientX - distance - childWidth : clientX - distance + 100;
    const mainTop = mainRef.current?.getBoundingClientRect().top || 0;

    return {
      x: Math.max(0, raw),
      y: Math.max(0, clientY - mainTop + 15),
    };
  };

  const handleRowEnter = useCallback((index: number, e: React.MouseEvent<HTMLDivElement>): void => {
    setHoveredRow(index);
    setBubblePos(calcPosition(e.clientX, e.clientY));
  }, []);

  const handleRowMove = useCallback((e: React.MouseEvent<HTMLDivElement>): void => {
    setBubblePos(calcPosition(e.clientX, e.clientY));
  }, []);

  const handleRowLeave = useCallback((): void => {
    setHoveredRow(-1);
  }, []);

  const hoveredItem = hoveredRow >= 0 ? item?.[hoveredRow] : null;

  return (
    <CardSlot title={mainTitle} secondTitle={secTitle} isEyes={true} className="dbd-progress-card" onDownload={handelDownload} hiddenDownload={isLoading || isError || isNoData}>
      <Abnormal
        isLoading={isLoading}
        style={{ height: '264px' }}
        isError={isError}
        isNoData={isNoData}
        component={
          <>
            <div ref={mainRef} className="dbd-progress-card-main" id="dbd-progress-card-main">
              <div className="dbd-progress-card-header-row">
                <div className="dbd-progress-card-padding dbd-progress-card-name-col">
                  <div className="dbd-progress-card-header">
                    <span>{header}</span>
                  </div>
                </div>
                {
                  dataList?.map((value: any, index: number) => {
                    const { title, listHeader } = value || {};
                    let sortIcon = <SvgIcon type="sort-icon" className="dbd-progress-card-icon"/>;
                    if(title === sortValue){
                      sortIcon = <SvgIcon type="arrow-other-down" className="dbd-progress-card-icon" style={{fontSize: '18px', marginTop: '-2px'}}/>;
                    }
                    return (
                      <div key={index} className="dbd-progress-card-padding dbd-progress-card-flex dbd-progress-flex-margin-side">
                        <div onClick={() => handleSort(title)} className={`dbd-progress-card-title ${index % 2 === 0 ? 'dbd-progress-card-justify' : ''} ${title === sortValue ? 'dbd-progress-card-selected' : ''}`}>
                          <span className='dbd-progress-card-title-span'>{listHeader}</span>
                          {sortIcon}
                        </div>
                      </div>
                    );
                  })
                }
              </div>
              <div className="dbd-progress-card-scroll">
                <div className="dbd-progress-card-padding dbd-progress-card-name-col">
                  <div className="dbd-progress-card-body">
                    {
                      item?.map((each: { name: string; bubble: any; }, i: number) => (
                        <div
                          key={i}
                          className="dbd-progress-flex"
                          onMouseEnter={(e) => handleRowEnter(i, e)}
                          onMouseMove={handleRowMove}
                          onMouseLeave={handleRowLeave}
                        >
                          <div className="dbd-progress-flex-left">
                            <div className="dbd-progress-bubble-main">
                              {each.name}
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
                {
                  dataList?.map((value: any, index: number) => {
                    const { footerFixed, list = [] } = value || {};
                    return (
                      <div key={index} className="dbd-progress-card-padding dbd-progress-card-flex dbd-progress-flex-margin-side">
                        <div className={`dbd-progress-card-body ${footerFixed ? 'footer-fixed' : null}`}>
                          {list?.map((listItem: any, i: any) => (
                            <div
                              key={i}
                              className="dbd-progress-flex"
                              onMouseEnter={(e) => handleRowEnter(i, e)}
                              onMouseMove={handleRowMove}
                              onMouseLeave={handleRowLeave}
                            >
                              <div className="dbd-progress-flex-center">
                                <div className={`dbd-progress-flex-text ${index % 2 === 0 ? "dbd-progress-flex-text-right" : "dbd-progress-flex-text-left"}`}>
                                  {listItem?.num}&nbsp;({listItem?.displayPercentage || listItem?.percentage})
                                </div>
                                <div
                                  className={`dbd-progress-flex-show ${index % 2 === 0 ? "dbd-progress-flex-show-right" : "dbd-progress-flex-show-left"}`}
                                  style={{ width: listItem?.percentage }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })
                }
              </div>
              {hoveredItem && (
                <div
                  ref={bubbleRef}
                  className="dbd-progress-card-bubble"
                  style={{ left: bubblePos.x, top: bubblePos.y }}
                >
                  <div className="dbd-progress-bubble-child">
                    {
                      Object.entries(hoveredItem.bubble).map(([key, value], i) => (
                        <div className={`dbd-progress-bubble-flex ${i > 0 ? 'dbd-progress-bubble-right' : ''}`} key={i}>
                          {key} <br/><br/>
                          {
                            i > 0 ? <strong>{String(value)}</strong> : <span>{String(value)}</span>
                          }
                        </div>
                      ))
                    }
                  </div>
                </div>
              )}
            </div>
          </>
        }
      />
    </CardSlot>
  );
};

export default MultiProgressCard;
